<template>
  <div class="page-title">
    <div class="row">
      <div class="col-sm-6 col-12">
        <h2>Independent Drivers</h2>
      </div>
    </div>
  </div>

  <div class="card height-equal-2">
    <div class="card-header card-no-border pb-0">
      <ul class="nav nav-tabs" id="icon-tab" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" id="all-drivers-tab" data-bs-toggle="tab"
             href="#all-drivers" role="tab" aria-controls="all-drivers" aria-selected="true">
            <i class="fa-solid fa-users text-primary"></i>
            All Drivers
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="active-drivers-tab" data-bs-toggle="tab"
             href="#active-drivers" role="tab" aria-controls="active-drivers" aria-selected="false">
            <i class="fa-solid fa-circle-check text-success"></i>
            Active Subscription
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" id="inactive-drivers-tab" data-bs-toggle="tab"
             href="#inactive-drivers" role="tab" aria-controls="inactive-drivers" aria-selected="false">
            <i class="fa-solid fa-circle-xmark text-danger"></i>
            Inactive Subscription
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content" id="icon-tabContent">
        <div class="tab-pane fade show active" id="all-drivers" role="tabpanel" aria-labelledby="all-drivers-tab">
          <DataTable
              :ajax="{ url: driversUrl}"
              ref="allDrivers" class="table-responsive display custom-datatable" :columns="columnDefinition"/>
        </div>

        <div class="tab-pane fade" id="active-drivers" role="tabpanel" aria-labelledby="active-drivers-tab">
                    <DataTable
                        :ajax="{ url: activeUrl}"
                        ref="activeDrivers" class="table-responsive display" :columns="columnDefinition"/>
        </div>

        <div class="tab-pane fade" id="inactive-drivers" role="tabpanel" aria-labelledby="inactive-drivers-tab">
                    <DataTable
                        :ajax="{ url: inactiveUrl}"
                        ref="inactiveDrivers" class="table-responsive display" :columns="columnDefinition"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net-bs5';
import {subscriptionStatus, userDetailsWithThumbnail, zonedDateTime} from "../utility/DatatableRenderer";
DataTable.use(DataTablesCore);

const driversUrl = `/api/datatable/independent-drivers`;
const activeUrl = `${driversUrl}?subscriptionStatus=ACTIVE`;
const inactiveUrl = `${driversUrl}?subscriptionStatus=INACTIVE`;

const columnDefinition = [
  {
    title: "Driver", data: "name", render: (data, type, row) => {
      return userDetailsWithThumbnail(data, row, `/admin/independent-driver/${row.id}`);
    }
  },
  {data: "email",title: "Email", },
  {data: "phoneNumber", title: 'Phone Number'},
  {data: "subscriptionType", title: 'Subscription Type', render: (data) => {
    if (!data) return '<span class="badge bg-secondary">None</span>';
    const typeClass = data === 'FULL_TIME' ? 'bg-primary' : 'bg-info';
    const label = data === 'FULL_TIME' ? 'Full Time' : 'Starter';
    return `<span class="badge ${typeClass}">${label}</span>`;
  }},
  {data: "subscriptionStatus", title: 'Subscription Status', render: subscriptionStatus},
  {
    data: "totalRides", title: 'Rides',orderable: false, searchable: false,
    render: (data, type, row) => {
      return `<span style="min-width: 125px;">
                    Total <span class="text-primary">${data || 0}</span> |
                    Completed <span class="text-success">${row.completedRides || 0}</span> |
                    Canceled <span class="text-danger">${row.cancelledRides || 0}</span>
              </span>`;
    }
  },
  {data: "onboardingStatus", title: 'Onboarding', render: (data) => {
    if (!data) return '<span class="badge bg-secondary">Unknown</span>';
    const statusMap = {
      'NOT_STARTED': { class: 'bg-secondary', label: 'Not Started' },
      'IN_PROGRESS': { class: 'bg-warning', label: 'In Progress' },
      'PENDING_VERIFICATION': { class: 'bg-info', label: 'Pending Verification' },
      'COMPLETE': { class: 'bg-success', label: 'Complete' },
      'REJECTED': { class: 'bg-danger', label: 'Rejected' }
    };
    const status = statusMap[data] || { class: 'bg-secondary', label: data };
    return `<span class="badge ${status.class}">${status.label}</span>`;
  }},
  {data: "joinedOn", title: 'Joined At', render: zonedDateTime},
  {
    title: 'Actions', orderable: false, searchable: false, render: (data, type, row) => {
      return `<a class="btn btn-outline-primary" data-id="${row.id}"
        href="/admin/independent-driver/${row.id}">
      <i class="iconly-Info-Circle icbr"></i> Details </a>`;
    }
  }
];

</script>
